import EnumSealLevel from "./gen/qsign/types/EnumSealLevel";
const labels = {
  [EnumSealLevel.QUALIFIED]: "Kvalifikovaný",
  [EnumSealLevel.GUARANTEED]: "Zaručený",
};
export function getCaption(source) {
  const caption = labels[source];
  return caption ? caption : "[" + source + "]";
}
